import React from 'react'

import {
    _getCreditPayment,
} from '../../services'

import {
    Card,
    Tag,
    Row,
    Col,
    Icon,
    Menu,
    Table,
    Checkbox,
    Upload,
    message,
    Dropdown,
    DatePicker,
    Button,
    Input,
    Modal
} from 'antd'

import BatchCounter from './batch-counter'
import PaymentAdviceButton from './payment-advice-button'

const { confirm } = Modal

const { RangePicker } = DatePicker

class CreditPaymentProfile extends React.Component{

    constructor(props){
        super(props)

        this.state = {
            payment: false,
            loading: true,
            data: [],
            batch: [],
    
            searchTerm: '',
            totalAmount: 0,
            refNumbers: [],
            batchDetails: [],
        }
    }

    render(){

        const { payment, refNumbers, batch, batchDetails, totalAmount } = this.state

        console.log({refNumbers, batchDetails, creditPaymentRefNumber: payment.refNumber,})
    
        return(
            <div style={{margin: 16}}>
                <Card
                    title={
                        <Row type="flex" justify="space-between">
                            <Col>
                                Ref No.: {payment.refNumber}
                                {payment.closed && <Tag style={{marginLeft: 12}} color="#f5222d">CLOSED</Tag> }
                            </Col>
                            <Col>
                                {/* <Button
                                    onClick={this.handleConfirmPaid}
                                    type="primary"
                                    disabled={payment.closed || this.state.batch.length == 0}
                                >
                                    Set Paid
                                </Button> */}
                                <PaymentAdviceButton 
                                    amount={totalAmount}
                                    refNumbers={refNumbers}
                                    batchDetails={batchDetails}
                                    creditPaymentRefNumber={payment.refNumber}
                                    getCreditPayment={this.getCreditPayment}
                                    />
                            </Col>
                        </Row>
                    }
                >   
                    {this.renderTable()}
                </Card>
            </div>
        )
    }

    componentDidMount() {
        this.getCreditPayment()
    }

    renderTable = () => {

        const { data, batch, loading, totalAmount } = this.state
        const readOnly = this.state.payment.closed

        if( loading ){
            return <div>Loading...</div>
        }

        const columns = [{
            title: "refNumber",
            dataIndex: 'refNumber',
            key:'refNumber'
        },{
            title: 'offlineReferenceNumberPretty',
            dataIndex: 'offlineReferenceNumberPretty',
            key: 'offlineReferenceNumberPretty'
        },{
            title: 'Price',
            dataIndex: 'amount',
            render: (amount) => amount.toFixed(2)
        },{
            title: 'Running Total',
            render:( x, y, index)=>{
                return data.slice(0, index + 1).reduce((acc, curr) => acc + curr.amount, 0.0 ).toFixed(2)
            }
        }]
        
        columns.unshift({
            key: 'checkbox',
            title: <Checkbox
                disabled={readOnly}
                checked={this.getAllChecked()}
                onChange={(e)=>this.handleCheckAll(e.target.checked)}
            />,
            dataIndex: 'cartId',
            render: (cartId, record) => {

                return(
                    <Checkbox
                        disabled={readOnly || record.paid}
                        checked={batch.includes(cartId)}
                        onChange={(e)=>this.handleCheck({cartId, checked: e.target.checked})}
                    />
                )
            }
        })

        return(
            <div>
                <Row type="flex" style={{marginBottom: 16}} gutter={16}>
                    <Col>
                        <Input
                            style={{width: 800}}
                            placeholder="Search product title or invoice no."
                            onChange={this.handleSearch}
                        />
                    </Col>
                    <Col>
                        <BatchCounter
                            clear={()=>this.handleCheckAll(false)}
                            length={this.state.batch.length}
                            total={data.length}
                            totalAmount={totalAmount}
                        />
                    </Col>
                </Row>
                <Table
                    loading={loading}
                    pagination={false}
                    dataSource={this.filterData(data)}
                    columns={columns}
                    expandedRowRender= {record => this.renderProductLineItems({record})}
                />
            </div>
        )

    }

    renderProductLineItems = ({record}) => {

        // var data = record.deliveryLineItems.invoiceComplete ? [...record.lineItems, record.deliveryLineItems] : record.lineItems
        var data = record.paymentRows

        const columns = [{
            title: "productTitle",
            dataIndex: 'description',
        },{
            title: 'quantity',
            dataIndex: 'deliveredQty',
        },{
            title: 'price',
            dataIndex: 'totalAmountWithGst',
            render: (price) => price.toFixed(2)
        }]

        return (
            <Table
                pagination={false}
                dataSource={data}
                columns={columns}/>
        )

    }

    getCreditPayment = () => {
        _getCreditPayment(this.props.paymentId)
        .then( res => {

            var { payment, groupedInvoices } = res.data

            this.handleCheckAll(false)
            this.setState({
                loading: false,
                data: groupedInvoices,
                payment,
            })
        })
    }

    getAllChecked = () => {

        const { batch, data } = this.state

        let allChecked = true

        data.map( _data => {
            if( !batch.includes( _data.cartId ) ){
                allChecked = false
            }
        })

        return allChecked
    }

    handleCheck = ({cartId, checked}) => {

        const { batch, data, batchDetails  } = this.state

        if( !checked ){
            this.setState({
                batch: batch.filter( _cartId => _cartId != cartId ),
                batchDetails: batchDetails.filter( _data => _data.cartId != cartId )
            },this.updateBatchDetails)
        } else{
            this.setState({
                batch: [...batch, cartId],
                batchDetails: [...batchDetails, data.filter( _data => _data.cartId == cartId )[0]]
            },this.updateBatchDetails)
        }

    }

    handleCheckAll = (checked) => {

        if( checked ){
            this.setState({
                batch: this.state.data.map( _data => _data.cartId ),
                batchDetails: this.state.data
            },this.updateBatchDetails)
        } else {
            this.setState({
                batch: [],
                refNumbers: [],
                batchDetails: [],
            },this.updateBatchDetails)
        }

    }

    updateBatchDetails = () => {
        // Updates totalAmount and refNumbers of the selected lines
        const {batch,data} = this.state

        console.log(this.state.batchDetails)

        let totalAmount = data
        .filter(_data => batch.includes(_data.cartId))
        .reduce((acc,cur)=> {
            return acc + cur.amount
        },0)

        let refNumbers = data
        .filter(_data => batch.includes(_data.cartId))
        .map( _data => _data.cartId )

        this.setState({
            totalAmount,
            refNumbers
        })
    }

    handleSearch = (e) => {
        this.setState({searchTerm: e.target.value})
    }
    
    filterData = (data) => {

        const { searchTerm } = this.state

        const regex = new RegExp(searchTerm, 'i')

        return data.filter( _data => regex.test(_data.description) || regex.test(_data.invoiceNumber) )

    }

}

export default CreditPaymentProfile


// WEBPACK FOOTER //
// ./src/components/credit-payment/profile.js